import React from 'react';
import MediaQuery from 'react-responsive';
import ReactPaginate from 'react-paginate';
import "./horizontalGridLoading.css"

const FeedPagination = props => {
    let { tournyPlayed, pageNumber, nextPage, isFullScreen } = props,
        pageCount = isFullScreen ? Math.floor(Number(tournyPlayed) / 15) + (Number(tournyPlayed) % 15 > 0 ? 1 : 0) : Math.floor(Number(tournyPlayed) / 5) + (Number(tournyPlayed) % 5 > 0 ? 1 : 0)
    return (
        <div>
            <MediaQuery minWidth={951} >
                {
                    isFullScreen
                        ?
                        props.loading ?
                            <div className="gridLoadingcontainer">
                                <div className="yellow animateGrid"></div>
                                <div className="red animateGrid"></div>
                                <div className="blue animateGrid"></div>
                                <div className="violet animateGrid"></div>
                            </div>
                        :
                         Math.ceil(Number(tournyPlayed) / 15) > 1 && tournyPlayed > 15 && !(pageCount - (pageNumber + 1) === 0) &&
                        <div onClick={() => props.nextPage(pageNumber + 1, tournyPlayed)}>
                            <i className='glyphicon glyphicon-chevron-down' style={{ color: '#FF4500', fontSize: "20px", paddingTop: "25px" }}></i>
                        </div>
                        : Math.ceil(Number(tournyPlayed) / 3) > 1 && tournyPlayed > 5 &&
                        <PaginateComp tournyPlayed={tournyPlayed} pageNumber={pageNumber} nextPage={nextPage} />
                }
            </MediaQuery>
            <MediaQuery maxWidth={950} >
                {
                    Math.ceil(Number(tournyPlayed) / 3) > 1 && tournyPlayed > 5 &&
                    <PaginateComp tournyPlayed={tournyPlayed} pageNumber={pageNumber} nextPage={nextPage} />
                }
            </MediaQuery>
            <MediaQuery maxWidth={730} >
                <div className={"border-bottom-tournamnet"}></div>
            </MediaQuery>
        </div>
    )
}
const PaginateComp = props => {
    let { tournyPlayed, pageNumber, nextPage } = props,
        pageCount = Math.floor(Number(tournyPlayed) / 5) + (Number(tournyPlayed) % 5 > 0 ? 1 : 0)
    return (<ReactPaginate
        previousLabel={<i className='glyphicon glyphicon-chevron-left' style={{ color: [0, tournyPlayed].includes((pageNumber)) ? '#999' : '#FF4500', cursor: 'pointer' }} />}
        nextLabel={<i className='glyphicon glyphicon-chevron-right' style={{ color: pageCount - (pageNumber + 1) === 0 ? '#999' : '#FF4500', cursor: 'pointer' }} />}
        breakLabel={''}
        pageCount={pageCount}
        activeLinkClassName={'tournyActivePage'}
        pageLinkClassName={'tournyPage'}
        marginPagesDisplayed={0}
        pageRangeDisplayed={2}
        onPageChange={nextPage}
        forcePage={pageNumber}
        containerClassName={'pagination'}
        subContainerClassName={'pages pagination'}
        activeClassName={'active'}
    />)


}
export default FeedPagination;


/** WEBPACK FOOTER **
 ** ./src/components/MyStatistics/tournamentFeedPagination.js
 **/